import styled from "styled-components";

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
